import { BeheerVosStation } from "@/entities/medewerkers-op-station/index.ts";
import { useApiClient } from "@/infrastructure/rest";
import { PatchVosStationBeheerDto, VosStationBeheerDto } from "@/shared/types";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { MEDEWERKERS_OP_STATION_STATIONS_QUERY_KEY, MEDEWERKERS_OP_STATION_VOS_QUERY_KEY } from "../constants.ts";

export function useGetBeheerVosStations() {
    const apiClient = useApiClient();

    return useQuery({
        queryKey: [MEDEWERKERS_OP_STATION_VOS_QUERY_KEY, MEDEWERKERS_OP_STATION_STATIONS_QUERY_KEY],
        queryFn: async () => {
            const data = await apiClient.get<VosStationBeheerDto[]>(`/vossen/stations`);
            return data?.map((station) => BeheerVosStation.fromDto(station))?.sort(BeheerVosStation.sort) ?? [];
        },
    });
}

type UpdateStationRequest = PatchVosStationBeheerDto & {
    stationcode: string;
};

export function useUpdateVosStation() {
    const queryClient = useQueryClient();
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async (data: UpdateStationRequest) => {
            await apiClient.patch(`/vossen/stations/${data.stationcode}`, data);
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: [MEDEWERKERS_OP_STATION_VOS_QUERY_KEY, MEDEWERKERS_OP_STATION_STATIONS_QUERY_KEY],
            });
        },
        onError: (error) => {
            console.error(`Fout bij het updaten VOS`, error);
        },
    });
}

export function useSyncVosMetStations() {
    const queryClient = useQueryClient();
    const apiClient = useApiClient();

    return useMutation({
        mutationFn: async () => {
            await apiClient.post(`/vossen/stations/sync`);
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: [MEDEWERKERS_OP_STATION_VOS_QUERY_KEY, MEDEWERKERS_OP_STATION_STATIONS_QUERY_KEY],
            });
        },
        onError: (error) => {
            console.error(`Fout bij het synchroniseren van VOS stations`, error);
        },
    });
}
